/** Listing values shared by the Redfin demo and property callouts. */
export const MEDICAL_LAKE_LISTING = {
  lotAreaSqFt: 6369,
  homeAreaSqFt: 2260,
};
